<script setup lang="ts">
import DropdownItemWrapper from "~/components/dumb/DropdownItemWrapper.vue";
import { usePageStore } from "~/stores";

defineProps<{
  label: string;
  selected: boolean;
  disabled: boolean;
  showOpen?: boolean;
  hideClose?: boolean;
  lineThrough?: boolean;
}>();

const emit = defineEmits<{
  open: [];
  remove: [];
}>();

const pageStore = usePageStore();
</script>

<template>
  <DropdownItemWrapper
    :selected="selected"
    :open-enabled="showOpen"
    :remove-enabled="!hideClose"
    :no-padding="!pageStore.isMobile && selected"
    :class="[
      !pageStore.isMobile ? 'overflow-hidden rounded' : 'justify-between text-base',
      !pageStore.isMobile && (selected ? 'min-h-[24px] bg-md py-0.5 pr-1 pl-1.5' : 'min-h-[20px]'),
    ]"
    @open="emit('open')"
    @remove="emit('remove')">
    <span
      :title="label"
      class="text-md"
      :class="{
        'break-words pr-0.5 hyphens-auto': selected,
        truncate: !selected,
        'line-through decoration-md': lineThrough,
        'opacity-50': disabled && !selected,
        'text-sm': !pageStore.isMobile,
        'text-base': pageStore.isMobile,
      }">
      {{ label }}
    </span>
  </DropdownItemWrapper>
</template>
